import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GuidedTour, GuidedTourService, Orientation } from 'ngx-guided-tour';
import { filter } from 'rxjs/operators';
import { NavService } from '../providers/nav.service';
import { SharedService } from '../shared.service';
// import { AuthService } from 'angularx-social-login';

declare var $;
declare let hopscotch;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  headerTitles: any = [
    {
      title: 'Home',
      src: 'assets/imgs/icons/icon_menu-dashboard.png',
      name: 'Dashboard icon',
      routePath: '/DashBoard'
    },
    {
      title: 'ChalkBoard',
      src: 'assets/imgs/icons/icon_menu-myboard.png',
      name: 'My Board icon',
      routePath: '/Board'
    },
    {
      title: 'Trends',
      src: 'assets/imgs/icons/icon_menu-trends.png',
      name: 'Trends icon',
      routePath: '/Trends'
    },
    {
      title: 'Last 5',
      src: 'assets/imgs/icons/icon_menu-last.png',
      name: 'Last 5 icon',
      routePath: '/Last5'
    },
    // {
    //   title: 'Manager',
    //   src: 'assets/imgs/icons/icon_menu-dashboard.png',
    //   name: 'Manager icon',
    //   routePath:'/Manager'
    // },
  ];
  activeHeader = '/DashBoard';
  loginDetails: any = {};
  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));
  previousUrl: string = null;
  currentUrl: string = null;
  public dashboardTour: GuidedTour = {
    tourId: 'board-tour',
    useOrb: false,
    steps: [
      // {
      //   title: 'Get in the game',
      //   content: 'This is how you use this screen.',
      //   selector: '.startTour',
      //   orientation: Orientation.Bottom
      // },
      {
        title: 'Help',
        content: 'You can always click here to restart the tutorial.',
        selector: '#helptour',
        orientation: Orientation.Bottom
      },
      {
        title: 'Get in the game',
        content: 'Select the game style and slate that you are going to play.  Do not forget to set your default platform and sport in the settings.',
        selector: '#options',
        orientation: Orientation.Bottom
      },
      {
        title: 'Categories',
        selector: '#board_wrapper',
        content: 'Hover over the categories for more information.',
        orientation: Orientation.TopRight
      },
      {
        title: 'Filters',
        content: 'Filters allow you to quickly find exactly who you are looking for.',
        selector: '#position',
        orientation: Orientation.Right
      },
      {
        title: 'Filters',
        content: 'This filter is only to see who is playing at home or away and does not apply to the statistics.',
        selector: '#hafilter',
        orientation: Orientation.Right
      },
      {
        title: 'Filters',
        content: 'Eliminate anomalies by excluding the high and low values.',
        selector: '#excludeVal',
        orientation: Orientation.TopRight
      },
      {
        title: 'Filters',
        content: 'In addition to statistics for each category, you can choose to see how a player ranks overall, or in their specific position.',
        selector: '#statsopt',
        orientation: Orientation.TopRight
      },
      {
        title: 'Adding Players',
        content: 'See a player you like?  Click here to add them to your player manager.',
        selector: '#check0',
        orientation: Orientation.Left
      },
      {
        title: 'Player profiles',
        content: 'Click on the players for more info.',
        selector: '#playname0',
        orientation: Orientation.Right,
        closeAction: (() => {
          // this.route.navigate(['/Trends'], { queryParams: { tour: 'yes' } });
        })
      }
    ]
  };

  public dashboardTour1: GuidedTour = {
    tourId: 'board-tour',
    useOrb: false,
    steps: [
      // {
      //   title: 'Get in the game',
      //   content: 'This is how you use this screen.',
      //   selector: '.startTour',
      //   orientation: Orientation.Bottom
      // },
      {
        title: 'Help',
        content: 'You can always click here to restart the tutorial.',
        selector: '#helptour',
        orientation: Orientation.Bottom
      },
      {
        title: 'Get in the game',
        content: 'Select the game style and slate that you are going to play.  Do not forget to set your default platform and sport in the settings.',
        selector: '#options',
        orientation: Orientation.Bottom
      },
      {
        title: 'Sign Up',
        content: "These slates have already finished.  Please <a href='/#/SignUp'>sign up</a> to access the current games styles and slates.",
        selector: '#latestSlates',
        orientation: Orientation.Bottom
      },
      {
        title: 'Categories',
        selector: '#board_wrapper',
        content: 'Hover over the categories for more information.',
        orientation: Orientation.TopRight
      },
      {
        title: 'Filters',
        content: 'Filters allow you to quickly find exactly who you are looking for.',
        selector: '#position',
        orientation: Orientation.Right
      },
      {
        title: 'Filters',
        content: 'This filter is only to see who is playing at home or away and does not apply to the statistics.',
        selector: '#hafilter',
        orientation: Orientation.Right
      },
      {
        title: 'Filters',
        content: 'Eliminate anomalies by excluding the high and low values.',
        selector: '#excludeVal',
        orientation: Orientation.TopRight
      },
      {
        title: 'Filters',
        content: 'In addition to statistics for each category, you can choose to see how a player ranks overall, or in their specific position.',
        selector: '#statsopt',
        orientation: Orientation.TopRight
      },
      {
        title: 'Adding Players',
        content: 'See a player you like?  Click here to add them to your player manager.',
        selector: '#check0',
        orientation: Orientation.Left
      },
      {
        title: 'Player profiles',
        content: 'Click on the players for more info.',
        selector: '#playname0',
        orientation: Orientation.Right,
        closeAction: (() => {
          // this.route.navigate(['/Trends'], { queryParams: { tour: 'yes' } });
        })
      }
    ]
  };
  public trendsTour: GuidedTour = {
    tourId: 'trends-tour',
    useOrb: false,
    steps: [
      {
        title: 'Trends',
        content: 'Compare up to 5 players and filter each one specifically to get a good idea of recent performance.',
        selector: '#addplay',
        orientation: Orientation.Right,
        closeAction: (() => {
          // this.route.navigate(['/Last5'], { queryParams: { tour: 'yes' } });
        })
      }
    ]
  };
  public last5Tour: GuidedTour = {
    tourId: 'last5-tour',
    useOrb: false,
    steps: [
      {
        title: 'Last 5',
        content: 'This shows how the last 5 players of the same position performed against the opponent.See how that compares to their previous 5 games before that to understand if the opponent typically holds players of that position above or below their average.',
        selector: '#postitle',
        orientation: Orientation.Top,
        closeAction: (() => {
          // this.route.navigate(['/Manager'], { queryParams: { tour: 'yes' } });
        })
      }
    ]
  };
  public managerTour: GuidedTour = {
    tourId: 'manager-tour',
    useOrb: false,
    steps: [
      {
        title: 'Manager',
        content: 'This is your personal Chalkboard where you can analyze the specific players that you are targeting and narrow them down to your winning lineup. Playing multiple slates? No problem!Save as many lists as you would like.',
        selector: '#tbm',
        useHighlightPadding: false,
        orientation: Orientation.Top,
        closeAction: (() => {
          // this.route.navigate(['/Manager'], { queryParams: { tour: 'yes' } });
        })
      }
    ]
  };
  constructor(
    private route: Router,
    // private authService:AuthService,
    private navService: NavService,
    public sharedService: SharedService,
    private guidedTourService: GuidedTourService,
    private router: Router
  ) {

    this.loginDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (this.loginDetails.isLogin) {
      const managerdata = {
        title: 'My Manager',
        src: 'assets/imgs/icons/icon_menu-dashboard.png',
        name: 'Manager icon',
        routePath: '/Manager'
      };

      this.headerTitles.push(managerdata);

    }
    const sub = this.navService.navObj$.subscribe(item => {
      if (item && item !== '/SignIn' && item !== '/SignUp') {
        this.activeHeader = item;
      }
    });
    this.sharedService.setPlayerCount();
  }

  ngOnInit() {
    if (this.loginUserDetails.isLogin) {
      this.getManagerCount();
    }

    if (window.location.href.indexOf('Last5') > 0 && (!localStorage.getItem('firstTimeLast5') || localStorage.getItem('firstTimeLast5')  !== "true")) {
      setTimeout(() => {
        localStorage.setItem('firstTimeLast5' ,'true')
        this.guidedTourService.startTour(this.last5Tour);
      }, 3000);
    }
    if (window.location.href.indexOf('Trends') > 0 && (!localStorage.getItem('firstTimeTrends') || localStorage.getItem('firstTimeTrends')  !== "true") ) {
      setTimeout(() => {
        localStorage.setItem('firstTimeTrends' , "true")
        this.guidedTourService.startTour(this.trendsTour);
      }, 3000);
    }

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      setTimeout(() => {

        switch (this.currentUrl) {
          case '/Board?tour=yes':
            this.restartTour();
            break;
          case '/Trends?tour=yes':
            this.startTrendsTour();
            break;
          case '/Last5?tour=yes':
            this.startLast5Tour();
            break;
          case '/Manager?tour=yes':
            this.startManagerTour();
            break;

          default:
            break;
        }
      }, 2000);

    });
  }
  // ngAfterViewInit(){

  // }
  onMenu(item) {
    this.activeHeader = item.routePath;
    this.route.navigate([item.routePath]);
  }

  onSettings(moveToId: string) {
    this.activeHeader = '/Settings';
    this.route.navigate(['/Settings']);
    if (moveToId) {
      setTimeout(() => {
        $('html, body').animate({
          scrollTop: $(moveToId).offset().top - 80
        }, 'slow');
      }, 100);
    }
  }

  onLogin() {
    // this.route.navigate(['/SignIn']);
    localStorage.clear();
    this.navService.changeNav('');
  }

  onLogout() {
    this.sharedService.onLogout();
  }

  showDetailPopup() {
    if (this.activeHeader == '/Board') {
      const tour = {
        id: 'hello-hopscotch',
        showPrevButton: true,
        steps: [
          {
            title: 'Help',
            content: 'You can always click here to restart the tutorial.',
            target: document.querySelector('#helptour'),
            placement: 'bottom',
            xOffset: -130,
            yOffset: -10
          },
          {
            title: 'Get in the game',
            content: 'This is how you use this screen.',
            target: document.querySelector('.startTour'),
            placement: 'bottom',
            xOffset: -130,
            yOffset: -10
          },
          {
            title: 'Customize your data',
            content: 'Select the game style and slate that you are going to play.  Do not forget to set your default platform and sport in the settings.',
            target: document.querySelector('#options'),
            placement: 'bottom',
            xOffset: 500,
          },
          {
            title: 'Category data',
            content: 'Hover over the categories for more information.',
            target: document.querySelector('#board_wrapper'),
            placement: 'bottom',
            xOffset: 500,
          },
          {
            title: 'Filter the Chalkboard®',
            content: 'Filters allow you to quickly find exactly who you are looking for.',
            target: document.querySelector('#filters'),
            placement: 'right',
            xOffset: 0,
          },
          {
            title: 'Filter Home/Away',
            content: 'This filter is only to see who is playing at home or away and does not apply to the statistics.',
            target: document.querySelector('#hafilter'),
            placement: 'right',
            xOffset: 0,
          },
          {
            title: 'Build your lineups',
            content: 'Click player names to view more stats, sort columns, and check off standout players to add to your Manager.',
            target: document.querySelector('#board'),
            placement: 'top',
            yOffset: -70
          }
        ]
      };

      hopscotch.startTour(tour);
    }

  }

  getManagerCount() {
    this.sharedService.getManagerCount();
  }

  public restartTour(): void {
    this.guidedTourService.startTour(this.dashboardTour);
  }

  public startTrendsTour(): void {
    this.guidedTourService.startTour(this.trendsTour);
  }

  public startLast5Tour(): void {
    this.guidedTourService.startTour(this.last5Tour);
  }

  public startManagerTour(): void {
    this.guidedTourService.startTour(this.managerTour);
  }




  startTutorial() {
    if (this.activeHeader.indexOf('/Board') !== -1 && this.loginDetails.isLogin == true) {
      this.guidedTourService.startTour(this.dashboardTour);
    }else{
      this.guidedTourService.startTour(this.dashboardTour1);
    }


    if (this.activeHeader.indexOf('/Trends') !== -1) {
      this.guidedTourService.startTour(this.trendsTour);
    }

    if (this.activeHeader.indexOf('/Last5') !== -1) {
      this.guidedTourService.startTour(this.last5Tour);
    }

    if (this.activeHeader.indexOf('/Manager') !== -1) {
      this.guidedTourService.startTour(this.managerTour);
    }
  }

}
